import { mapActions, mapMutations, mapStates, mapGetters } from './../baseModule'
import { dashboardCustomersCounter } from 'src/services/DashboardCounter.js'

const collection = 'users'
const singleName = 'user'
const connection = 'config'

const model = {
  name: '',
  login: '',
  password: '',
  confirmPassword: '',
  role: '',
  inactivate: false
}
const validations = {
  name: {
    required: true
  },
  login: {
    required: true,
    min: 5
  },
  password: {
    required: true,
    min: 5
  },
  confirm: {
    required: true
  },
  role: {
    required: true
  }
}
let getters = {...mapGetters()}
getters[singleName] = (state) => {
  return Object.assign({}, JSON.parse(JSON.stringify(model)), state.one)
}
getters = Object.assign(getters, {
  users: state => state.all,
  selected: state => state.userSelected,
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count,
  noAdminAll: state => state.all.filter(item => item.role !== 'superadmin'),
  showInactivate: state => state.showInactivate,
  usersIdName: state => {
    return state.all && state.all.length > 0 ? state.all.filter(item => {
      return item.role !== 'superadmin' && (state.showInactivate || !item.inactivate)
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name)
    }).reduce((obj, item) => {
      obj[item._id] = item.name
      return obj
    }, {}) : {}
  }
})
export default {
  namespaced: true,
  state: {
    ...mapStates(),
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    loading: true,
    editing: false,
    count: 0,
    userSelected: {},
    showInactivate: false
  },
  mutations: {
    ...mapMutations(),
    SET_SHOW_INACTIVATE: (state, payload) => {
      state.showInactivate = payload
    },
    setUserSelected: (state, payload) => {
      state.userSelected = payload
    }
  },
  actions: {
    ...mapActions(collection, model, connection),
    setShowInactivate ({ commit }, payload) {
      commit('SET_SHOW_INACTIVATE', payload)
    },
    setUserSelected ({ commit }, { user }) {
      commit('setUserSelected', user)
    },
    dashboardUsersByFilter (context, { dateRange }) {
      context.commit('changeLoading', true)
      dashboardCustomersCounter(dateRange)
        .then(result => {
          context.commit('SET_DASHBOARD_COUNTER', result)
        })
        .finally(() => context.commit('changeLoading', false))
    }
  },
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/users.js